module.exports = __webpack_public_path__ + "img/404Infl.91d9f6c6.svg";